import React from 'react';

const Training = () => {
  return (
    <iframe
      src="https://v2-embednotion.com/Training-473fbb17df5f41bb9080164f25205d51"
      title="Training"
      style={{
        width: '100%',
        height: '600px',
        border: '1px solid #ccc',
        borderRadius: '10px',
        padding: 'none',
        boxShadow: '0 2px 2px #ccc '
      }}
    />
  );
};

export default Training;
